<div class="sticky-top" id="section-propriete">
  <app-back-to-top></app-back-to-top>
</div>
<div>
  <!-- Div to make sticky-top work on ios -->
  <router-outlet></router-outlet>
</div>
